<template>
  <component
    :is="tag"
    class="inline-flex items-center whitespace-no-wrap p-5 border-0 focus:outline-none leading-tight transition-all"
    :class="[{'hover:opacity-100': hasHover }, opacityStyle, classes]"
    @mouseover="toggleTooltip(true)"
    @mouseleave="toggleTooltip(false)"
  >
    <!-- T O O P T I P  T E X T -->
    <p
      v-if="tooltipText && showTooltip && !isMobile"
      class="shadow text-main-color absolute left-1/2 transform -translate-x-1/2 px-10 py-4 rounded-4 capitalize"
      :class="[isDarkMode ? 'bg-white text-backdrop' : 'bg-backdrop text-white', tooltipPosition, `text-${tooltipSize}`]"
    >
      {{ tooltipText }}
    </p>

    <i v-if="prefix" :class="[prefix, { 'mr-10': iconHasMargin && text }]" />

    <slot>
      <span v-if="text" class="truncate">{{ text }}</span>
    </slot>

    <i v-if="!!suffix" :class="suffix" />
  </component>
</template>

<script>
import { useStore } from 'vuex'
import { defineComponent, computed, ref } from 'vue'

export default defineComponent({
  name: 'ButtonModule',

  props: {
    text: { type: String, required: false },
    prefix: { type: String, required: false },
    suffix: { type: String, required: false },
    hasHover: { type: Boolean, default: false },
    tag: { type: String, default: 'button' },
    tooltipText: { type: String, default: '' },
    tooltipPosition: { type: String, default: 'bottom-40' },
    buttonOpacity: { type: String, default: '50' },
    tooltipSize: { type: String, default: '10' },
    iconHasMargin: { type: Boolean, default: true },
    groupHoverColor: { type: String, default: '' },
    classes: { type: String, default: 'duration-300' }
  },

  setup (props) {
    const { getters } = useStore()

    const showTooltip = ref(false)

    const isMobile = computed(() => getters.isMobile)
    const isDarkMode = computed(() => getters.isDarkMode)
    const opacityStyle = computed(() => props.hasHover ? `opacity-${props.buttonOpacity}` : '')

    const toggleTooltip = (value) => {
      showTooltip.value = value
    }

    return { showTooltip, isMobile, isDarkMode, opacityStyle, toggleTooltip }
  }
})
</script>
